import { TransactionKind } from 'storeTypes'

export const getAmountColor = ({
    type,
    amount = 0,
    allEnrollment
}: {
    type: TransactionKind
    amount: number
    allEnrollment: number
}) => {
    if (type === TransactionKind.PENDING) return ''
    if (amount < 0) return 'deducted-amount'
    if (allEnrollment <= 0) return 'amount-potential'
    return 'amount'
}
